import { TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import STRING_KEYS from '../../../../language/keys';
import { style } from './style';

type EmailDomainTextFieldProps = {
  value: string,
  helperText: string,
  error?: boolean,
  onChange: (value: string) => void,
}

export const EmailDomainTextField = ({
  value,
  onChange,
  helperText,
  error,
}: EmailDomainTextFieldProps):JSX.Element => {
  const { t: translate } = useTranslation();

  return (
    <TextField
      variant="outlined"
      fullWidth
      name="allowedEmailDomain"
      value={ value }
      placeholder="domain.com"
      margin="dense"
      // sx={ style.TextField.sx }
      label={ translate(STRING_KEYS.EMAIL_DOMAIN) }
      helperText={ helperText }
      error={ error }
      InputProps={ {
        startAdornment: (
          <Typography variant="body1" sx={ style.Typography.sx }>
            @
          </Typography>
        ),
      } }
      onChange={ (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e.target.value);
      }  }
    />
  );
};

EmailDomainTextField.defaultProps = {
  error: false,
};
